import { render, staticRenderFns } from "./image.template?vue&type=template&id=464fc173&scoped=true&lang=pug&"
import script from "./image.client?vue&type=script&lang=ts&"
export * from "./image.client?vue&type=script&lang=ts&"
import style0 from "./image.style?vue&type=style&index=0&id=464fc173&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464fc173",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('464fc173')) {
      api.createRecord('464fc173', component.options)
    } else {
      api.reload('464fc173', component.options)
    }
    module.hot.accept("./image.template?vue&type=template&id=464fc173&scoped=true&lang=pug&", function () {
      api.rerender('464fc173', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/attachments/viewer/image/image.component.vue"
export default component.exports